<template>
    <div>
        <div class="center-this">
            <!--<div class="microsite-container center-text">
                <div class="microsite-text">
                    <img src='../../assets/csl-star.png'/>
                </div>
                <div class='microsite-link'>
                    <a src='../assets/csl-star.png' href='https://www.dinesafevt.co/benefit-for-the-diner'>Learn about DineSafeVT</a>
                </div>
            </div>-->
            <div class="date-range">
                <DxDateBox
                    type="date"
                    ref="dateRef"  
                    :show-clear-button="true"
                    @valueChanged="dateValueChanged"
                    :value.sync="filterDate"
                    placeholder="Date"
                >
                    <DxDateBoxButton name="dropDown"/>
                    <DxDateBoxButton
                       :options="btnTodayOptions"
                        name="today"
                        location="after"
                    />
                    
                </DxDateBox>
            </div>
        </div>

        <div class="home-search"> 
            <DxTextBox
                placeholder="Search by Name, E-mail, Phone, Address"  
                ref="searchBoxRef"  
                :show-clear-button="true"
                :value.sync="searchText"
                @enterKey="this.searchClick"
            >
                <DxTextBoxButton
                    :options="searchButtonOptions"
                    name="btnSearch"
                    location="after"
                />
            </DxTextBox>
        </div>

        <DxButton 
            ref="btnEmailRef" 
            :width="120"
            type="normal"
            text="E-mail"
            icon="email"
            styling-mode="outlined"
            @click="btnEmailClick"
            :visible="false"
        />

        <DxButton 
            ref="btnStateReportRef" 
            :width="180"
            type="normal"
            text="State Report"
            icon="export"
            styling-mode="outlined"
            :visible.sync="gridVisible"
            @click="btnStateReportClick"
        />
        <div class="email-padding"/>

        <DxDataGrid
            ref="gridRef"
            :data-source="tableNames"
            :visible.sync="gridVisible"
            :paging="{enabled: false}"
            key-exp="LocationId"
            @row-click="gridRowClick"
            @selection-changed="gridSelectionChanged"
            @cell-prepared="onCellPrepared"
            @row-prepared="onRowPrepared"
            :customize-columns="gridCustomizeColumns"
            :show-borders="true"    
            :selection="{ mode: 'multiple', showCheckBoxesMode: 'always' }" 
        >
        <!-- :selection="{ mode: 'multiple', showCheckBoxesMode: 'always' }" -->

            <template #row-checkbox="{ data: row }">
                <div class="row-checkbox">
                    <DxCheckBox                       
                        :onValueChanged="function(e) {  
                            //Select/deselect the row when the checkbox is clicked.
                            var keys = [];  
                            for (var i = 0; i < row.data.items.length; i++) 
                            { 
                                keys.push(row.data.items[i].KeyField);  
                            }
                            if (e.value)  
                                grid.selectRows(keys, true);  
                            else  
                                grid.deselectRows(keys);  
                        }"
                    />                    
                </div>
            </template>

            <!--<DxColumn
                data-field="Selected"
                caption=""
                data-type="boolean"
                :allow-exporting="true"
                :visible="true"
            />-->
            <DxColumn
                data-field="Date"
                caption="Date"
                data-type="datetime"
                :visible="false"
            />
            <DxColumn
                data-field="LocationName"
                caption="Table Name"
                data-type="text"
                
                group-cell-template="groupTemplate"
                width="auto"
            />
            <DxColumn
                data-field="LocationDescription"
                caption="Description"
                data-type="text"
                
            />
            <DxColumn
                data-field="Name"
                caption="Name"
                data-type="text"
                :visible="false"
            />
            <DxColumn
                data-field="Phone"
                caption="Phone"
                data-type="text"
                :visible="false"
            />
            <DxColumn
                data-field="Email"
                caption="E-mail"
                data-type="text"
                :visible="false"
            />
            <DxColumn
                data-field="Address"
                caption="Address"
                data-type="text"
                :visible="false"
            />
            <DxColumn
                data-field="City"
                caption="City"
                data-type="text"
                :visible="false"
            />
            <DxColumn
                data-field="State"
                caption="State"
                data-type="text"
                :visible="false"
            />
            <DxColumn
                data-field="ZipCode"
                caption="Postal Code"
                data-type="text"
                :visible="false"
            />
            <DxMasterDetail
                ref="masterDetailRef"
                :enabled="false"
                template="masterDetailTemplate"
                :autoExpandAll="true"
            />
            <template #masterDetailTemplate="{ data: masterdata }">
                <DetailTemplate
                    :template-data="masterdata"
                    :masterDataSource="gridData"
                    filter="john"
                />
            </template>

            <template #groupTemplate="{ data: row }">
                <div class="dinesafe-group-row">
                    <DxCheckBox 
                        :text="row.data.key"
                        @value-changed="groupCheckClicked($event, row)"
                    />                    
                </div>
            </template>
        </DxDataGrid>
    </div>
</template>

<script>
    
import { DxDataGrid, DxColumn, DxMasterDetail, DxSelection, DxGrouping, DxExport} from 'devextreme-vue/data-grid';
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import { DxDateBox, DxButton as DxDateBoxButton } from 'devextreme-vue/date-box';
import DxButton from 'devextreme-vue/button';
import { DxCheckBox } from 'devextreme-vue/check-box';
import adminData from '../../../src/data/admin-data.js';
import shared from '../../utils/contact-tracing-functions';
import DetailTemplate from './admin-related-contacts-detail';
import notify from 'devextreme/ui/notify';

import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';

export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxMasterDetail,
        DxTextBox,
        DxButton,
        DxTextBoxButton,
        DxDateBoxButton,
        DxDateBox,
        DetailTemplate,
        DxSelection,
        DxGrouping,
        DxCheckBox,
        DxExport,
    },
    data() {
        return {
            gridData: null, //this.$store.state.data.accountContactHistory,
            //gridData: adminData.getAdminHomeTestData()[0].AdminHomeTestRecord[0].rows, //Hardcoded data for demo-ing when Kamal breaks the stored proc
            tableNames: null,
            searchText: '',
            filterDate: null,
            gridVisible: false,
            searchButtonOptions: {
                //icon: 'images/icons/eye.png',
                icon: 'search',
                type: 'default',
                onClick: this.searchClick,
                /*onClick: (value) => {
                    //"this" is the button
                }*/
            },
            clearButtonOptions: {
                icon: 'clear',
                type: 'default',
                onClick: this.searchClick,
            },
            btnTodayOptions: {
                text: 'Today',
                class: 'today-button',
                stylingMode: 'outlined',
                onClick: () => {
                    this.filterDate = new Date().getTime();
                }
            },
        };
    },
    created(){
        //Load information to the DataGrid
        //this.getAccountContactHistory(this.$store.state.data.currentAccountId);
        this.getAccountContactHistory(localStorage.dinesafeAccountId);

        if(localStorage.dinesafeData != null && localStorage.dinesafeData != '')
        {
            //This updates the name of the logged in user in the top right
            this.$store.commit("setEmail", JSON.parse(localStorage.dinesafeData).Email);
        }
    },
    mounted(){

    },
    methods: {
        /*
            When the Email button is clicked, build a pipe-delimited list of UserIds from the records that are selected in the grid,
            and send the list of UserIds to the web service.  The web service will run a stored proc that sends out e-mails to those users.
            Stored Proc = pr_admin_SendEmailNotifications
        */
        btnEmailClick(e){
            //console.log("btnEmailClick");

            //Get an array of selected records
            var selectedRecords = this.gridData.filter(row => row.Selected ==1);

            //Loop through the array, build a pipe-delimited string of e-mail addresses
            //var lookup = {};
            //var items = this.gridData;
            //var result = [];
            var selectedUsers = '';

            for (var item, i = 0; item = selectedRecords[i++];) {
                if(item.UserId != null){
                    selectedUsers += item.UserId + '|';
                }
            }

            //console.log('selectedUsers: ' + selectedUsers);

            //Hit the web service / run the stored proc
            this.$http.post(this.$store.state.appSettings.webServiceUrl + 'SendEmailNotifications',
            {
                //AccountId: this.$store.state.data.currentAccountId,
                AccountId: localStorage.dinesafeAccountId,
                UserIdList: selectedUsers,
            }
            ).then(function(data){         
                //var responseData = JSON.parse(data.body); 
                                
                if(selectedRecords != ''){
                    //Display a Success message
                    notify(
                        {
                            message: "Report has been sent", 
                            type:'success', 
                            width:'auto', 
                            displayTime:2000,
                            position: {
                                my: 'center center',
                                at: 'center center'
                            }
                        }
                    );
                }
            });   
                     
        },
        /*
            Get the history of Contact Info data for this account.  This is used for populating the grid on the Home tab for Admins
            Stored Proc = pr_admin_pullCustomerData_json
        */
        getAccountContactHistory(accountId){        
            this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetAccountContactHistory',
            {
                AccountId: accountId,
                VisitDate: this.filterDate == null ? null : '\/Date(' + new Date(this.filterDate).valueOf() + ')\/',
                SearchText: this.searchText,
            }
            ).then(function(data){         
                var responseData = JSON.parse(data.body);   
                
                this.$store.commit("setAccountContactHistory", responseData["AccountContactHistory"]);

                this.gridData = this.$store.state.data.accountContactHistory;

                this.getTableNames();
            });
        },
        /*
            Filter a unique list of TableNames, and set it as the datasource of the grid.
        */
        getTableNames(){
            //If the grid doesn't have any data, return
            if(this.gridData == null){
                return;
            }

            var lookup = {};
            var items = this.gridData;
            var result = [];

            //Get a list of unique TableNames
            for (var item, i = 0; item = items[i++];) {
                
                if (!(item.LocationName in lookup)) {
                    lookup[item.LocationName] = 1;
                    result.push({
                                    LocationName: item.LocationName,
                                    LocationDescription: item.LocationDescription
                                });
                }
            }

            //Store the list
            this.tableNames = result;
        },
        /*
            Handle the Changed event for the search date
        */
        dateValueChanged({ value }) {
           // const dataGrid = this.$refs.gridRef.instance;

            //console.log("dateValueChanged");

            //value = Wed Sep 09 2020 12:26:00 GMT-0400 (Eastern Daylight Time)
            //value.toLocaleString() = "9/9/2020, 12:26:00 PM"

            //dataGrid.clearFilter();
        },
        /*
            Handle the Click event of the search button (the magnifying glass icon)
        */
        searchClick(e){
            //console.log("Search clicked");   

            //Get the text from Search box
            /*var filterValue = this.searchText;

            //Filter the data in the grid.  Every column is included in the filter
            this.$refs.gridRef.instance.filter([
                ["Date","contains", filterValue],
                "or",
                ["LocationName","contains", filterValue],
                "or",
                ["LocationDescription","contains", filterValue],
                "or",
                ["Name","contains", filterValue],
                "or",
                ["Phone","contains", filterValue],
                "or",
                ["Email","contains", filterValue],
                "or",
                ["Address","contains", filterValue],
                "or",
                ["City","contains", filterValue],
                "or",
                ["State","contains", filterValue],
                "or",
                ["ZipCode","contains", filterValue],
            ]);*/

            //Pass the filter Date and Text and get data from the database
            //this.getAccountContactHistory(this.$store.state.data.currentAccountId);
            this.getAccountContactHistory(localStorage.dinesafeAccountId);

            this.gridVisible = true;         

            //Collapse any "detail" records
            this.$refs.gridRef.instance.collapseAll(-1);

            //Clear the row selection
            this.$refs.gridRef.instance.clearSelection();
        },
        /*
            Handle the RowClick event of the grid.  When row with a TableName is clicked, it will expand to reveal the contact history of the table, filtered
            on the Search criteria
        */
        gridRowClick(e){
            //console.log("gridRowClick");

            //Don't do anything for detail rows
            if(e.rowType=='detail'){
               return;
            }

            //If the row is already expanded, collapse it, clear the selection
            if(this.$refs.gridRef.instance.isRowExpanded(e.key)){
                this.$refs.gridRef.instance.collapseAll(-1);
                this.$refs.gridRef.instance.clearSelection();
            }
            else if(e.rowType != 'group'){
                //If this isn't a Group row, collapse any expanded rows, expand the row that was clicked
                this.$refs.gridRef.instance.collapseAll(-1);
                 this.$refs.gridRef.instance.expandRow(e.key);
            }
        },
        /*
            Handle the SelectionChanged event of the grid.
            When a user clicks the checkbox to select a row, select all the Detail rows under the Master row that was selected
        */
        gridSelectionChanged(e) {
            console.log("gridSelectionChanged");

            //Note - The grid is bound to  this.gridData
            //ToDo - Update this.gridData - Set record.Selected = 1 Where record.LocationName = e.selectedRowsData[0].LocationName

            var lookup = {};
            var items = this.gridData;
            var result = [];

            //Loop through the selectedRows, select the detail records
            for(var row, i = 0; row = e.selectedRowsData[i++];){
                //Loop through the dataSource of the grid
                for (var item, j = 0; item = items[j++];) {
                    //If the LocationName matches, set Selected to true
                    if (item.LocationName == row.LocationName) {
                        item.Selected = true;
                    }
                }
            }

            //Loop through the deselectedRows, deselect the detail records
            for(var row, i = 0; row = e.currentDeselectedRowKeys[i++];){
                //Loop through the dataSource of the grid
                for (var item, j = 0; item = items[j++];) {
                    //If the LocationName matches, set Selected to false
                    if (item.LocationName == row.LocationName) {
                        item.Selected = false;
                    }
                }
            }


            //Store the list
            //this.tableNames = result;

            //If the row is already expanded, collapse it
            /*if(this.$refs.gridRef.instance.isRowExpanded(e.currentSelectedRowKeys[0])){

            }
            else{
                e.component.collapseAll(-1);
                e.component.expandRow(e.currentSelectedRowKeys[0]);
            }*/            
        },
        /*
            Handle the CellPrepared event of the grid
        */
        onCellPrepared(e){
            if(e.rowType == 'group'){
                if(e.columnIndex == 0){
                    var temp = 0;
                }
            }
        },
        /*
            Handle the RowPrepared event of the grid
        */
        onRowPrepared(e){
            if(e.rowType == 'group'){
                //this.$parent.$parent.$parent.$refs.theGrid.instance.getVisibleRows()[sampleRowIdx].cells[1].cellElement.innerHTML = '<div class="blue-box"></div>';

                //AJT Idea - Clear out the HTML for the first 2 cells in the Group row

                //if(e.columnIndex == 0){
                    //e.values.push(true);
                    //e.cells[0].value = true
                    //e.columns[0].visibleIndex = 10;
                   
                    var tempCell = e.cells[0];

                    //Remove the first 2 cells
                    //var removed = e.cells.splice(0,1);

                    //e.rowElement.innerHTML = '<td colspan="9" aria-selected="false" role="gridcell" aria-colindex="2" style="text-align: left;"></td>';

                    // e.cells[0].cellElement.outerHTML = '';
                    // e.cells[1].cellElement.outerHTML = '';

                    //e.cells.push[tempCell];

                    //e.rowElement.innerHTML += '<td></td><td></td>'

                    //e.rowElement.innerHTML  = '<td colspan="8" aria-selected="false" role="gridcell" aria-colindex="2" style="text-align: left;">' + 
                    //    e.data.key + '<td></td><td></td>';

                    //This works visually, but the checkbox isn't functional.
                    /*e.rowElement.innerHTML = 
                     '<td colspan="10" aria-selected="false" role="gridcell" aria-colindex="2" style="text-align: left;"><div data-v-371068f7="" class="dx-template-wrapper">'
                     + '<div data-v-371068f7="" class="dx-show-invalid-badge dx-checkbox dx-checkbox-has-text dx-widget" role="checkbox" aria-checked="false" tabindex="0">'
                     + '<input type="hidden" value="false"><div class="dx-checkbox-container"><span class="dx-checkbox-icon" title=""></span><span class="dx-checkbox-text">'
                     + e.data.key + '</span></div></div></div></td>'*/

                    
                    //console.log(e.rowElement.innerHTML);
                    

                    //e.cells[0].column.colspan = 12;

                    //e.rowElement.innerHTML =
                    //"<td colspan="9" aria-selected="false" role="gridcell" aria-colindex="2" style="text-align: left;"></td>"
                    
                    //e.cells.push(tempCell);
                    //e.cells.push(tempCell);

                    var temp = 0;
                //}
            }
        },
        /*
            Handle the CustomizeColumns event of the grid
        */
        gridCustomizeColumns(columns){
            var temp = 0;
            //columns[1].index = 5;
            //columns[4].visible = false;
        },
        /*
            Handle the ValueChanged event of the checkbox at the group level in the grid.
            2020/09/10 - This is not currently being used.
            This uses the built in grid selection to select the group row when the checkbox is clicked.
        */
        groupCheckClicked(e, row){  
            console.log("groupCheckClicked");
            //Select/deselect the row when the checkbox is clicked.
            var keys = [];  
            var test;
            for (var i = 0; i < row.data.items.length; i++)  
                keys.push(row.data.items[i].KeyField);  
            if (e.value){ 
                this.$refs.gridRef.instance.selectRows(keys, true);  
            }
            else{
                this.$refs.gridRef.instance.deselectRows(keys);  
            }
        },
        /*
            Generate an Excel document polulated with the selected records in the grid
            ExcelJS - https://github.com/exceljs/exceljs
        */
        btnStateReportClick(e){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('DineSafeVT Export');

            worksheet.addRow(['Restaurant', 'Table', 'Visit Date', 'First Name', 'Last Name', 'Phone Number', 'E-mail']);;

            //Get the selected records in the grid
            var selectedRecords = this.gridData.filter(row => row.Selected ==1);

            //Loop through the records that are selected in the grid, and add the data to the Excel worksheet
            for (var item, i = 0; item = selectedRecords[i++];) {
                if(item.UserId != null){
                    worksheet.addRow([this.$store.state.data.currentAccountName, item.LocationName, item.createdOn, item.FirstName, item.LastName, item.PhoneNumber, item.Email]);;
                }
            }


            // write to a file
            //const workbook = createAndFillWorkbook();
            //var fileName ='test.xlsx';
            //workbook.xlsx.writeFile(fileName);

            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DineSafeVT Export.xlsx');
            });
        },
    }
}



</script>

<style>

    /* Put some space between the TODAY button and the line below it */
    .dx-button[aria-label='Today']{
         margin-bottom: 5px;
    }

</style>

<style scoped>
    @import '../../themes/contact-tracing.css';

    /* Admin Home Search box */
    .home-search {
        /*position: absolute;
        right: 1px;
        top: 6px;*/

        display: block; /* display: block */
        padding-bottom: 30px;
        padding-top:10px;

        margin:auto;
        max-width: 400px;
    }

    .center-this{
        display:block;
        margin:auto;
        max-width: 400px;
    }

    /* Admin Home - Start */

    /* Dates */
    /*.date-range {
        /*display:flex;*/ /*uncomment if I'm using To and From dates */
    /*}*/

    .date-label{
        align-self: center;
        padding-right: 15px;
    }

    /* The checkbox in a group row */
    .dinesafe-group-row > .dx-checkbox{
        font-weight:bold;
    }

    /* Line up the checkbox for specific rows with the checkbox at the group level */
    .row-checkbox{
        text-align:left;
    }

    .email-padding{
        height:15px;
    }

    .dx-button-mode-outlined

    .today-button{
        padding: 10px;
    }

    /* Admin Home - End */
</style>